import { Vue, Prop } from 'vue-property-decorator';

export default class CustomLoadingIndicator extends Vue {
    @Prop() public inFlight: boolean;
}
